import React from 'react';
import { Loader2 } from 'lucide-react';

export default function LoadingSpinner({ label = 'Carregando...', size = 20, className = '' }) {
  return (
    <div className={`flex items-center justify-center gap-2 py-8 text-sm text-slate-500 ${className}`}>
      <Loader2 size={size} className="animate-spin text-slate-400" />
      <span>{label}</span>
    </div>
  );
}
